import AnswerBlank from './AnswerBlank';
import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { getSiteEngine } from '../../data/sitePages';

function MatchingTable({ title, rows, showAnswers }) {
  return (
    <section className={WORKSHEET_CLASSES.part}>
      <h2 className={WORKSHEET_CLASSES.partTitle}>{title}</h2>
      <table className={WORKSHEET_CLASSES.table}>
        <tbody>
          {rows.map(({ clue, answer }) => (
            <tr key={clue}>
              <th scope="row">{clue}</th>
              <td>
                <AnswerBlank answer={answer} showAnswer={showAnswers} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

/**
 * Part A: symbol to name. Part B: name to symbol.
 */
export default function SpotTheElementSheet({ worksheet, showAnswers }) {
  const engine = getSiteEngine();
  const symbolRows = worksheet.symbolsToName.map((id) => {
    const element = engine.getSubstance(id);
    return { clue: element.symbol, answer: element.name };
  });
  const nameRows = worksheet.namesToSymbol.map((id) => {
    const element = engine.getSubstance(id);
    return { clue: element.name, answer: element.symbol };
  });

  return (
    <>
      <MatchingTable title="Part A: What is the name of each element?" rows={symbolRows} showAnswers={showAnswers} />
      <MatchingTable title="Part B: What is the symbol for each element?" rows={nameRows} showAnswers={showAnswers} />
    </>
  );
}
